<template>
  <section class="a-stat" :class="{ 'a-stat--accent': accent }">
    <div class="a-stat__row">
      <div class="a-stat__main">
        <p class="a-stat__label">
          <i v-if="icon" class="material-icons-round a-stat__icon">{{ icon }}</i>
          {{ label }}
        </p>
        <h3 class="a-stat__value">
          <span class="a-stat__num">{{ formattedValue }}</span>
          <span v-if="unit" class="a-stat__unit">{{ unit }}</span>
        </h3>
      </div>
      <div v-if="delta !== null && delta !== ''" class="a-stat__delta" :class="deltaClass">
        <i class="material-icons-round">{{ deltaIcon }}</i>
        <span>{{ Math.abs(Number(delta)) }}{{ deltaUnit }}</span>
      </div>
    </div>
    <p v-if="hint" class="a-stat__hint">{{ hint }}</p>
  </section>
</template>

<script>
export default {
  name: 'AStat',
  props: {
    label: { type: String, required: true },
    value: { type: [String, Number], default: '' },
    unit:  { type: String, default: '' },
    delta: { type: [String, Number, null], default: null },
    deltaUnit: { type: String, default: '%' },
    hint:  { type: String, default: '' },
    icon:  { type: String, default: '' },
    accent:{ type: Boolean, default: false },
  },
  computed: {
    formattedValue() {
      if (this.value === '' || this.value === null || this.value === undefined) return '';
      if (typeof this.value === 'number') return this.value.toLocaleString('ko-KR');
      return this.value;
    },
    deltaClass() {
      const d = Number(this.delta);
      if (isNaN(d) || d === 0) return 'a-stat__delta--neutral';
      return d > 0 ? 'a-stat__delta--up' : 'a-stat__delta--down';
    },
    deltaIcon() {
      const d = Number(this.delta);
      if (isNaN(d) || d === 0) return 'remove';
      return d > 0 ? 'arrow_upward' : 'arrow_downward';
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/pineapple';

.a-stat {
  background: $p-panel;
  border: 1px solid $p-line;
  border-radius: $p-radius-lg;
  padding: 20px 22px;
  display: flex;
  flex-direction: column;
  gap: 10px;

  &--accent {
    background: $p-point-soft;
    border-color: $p-point;
  }
}

.a-stat__row {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 8px;
}

.a-stat__main {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.a-stat__label {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin: 0;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.04em;
  color: $p-ink-mid;
}

.a-stat__icon {
  font-size: 16px !important;
  color: $p-point-deep;
}

.a-stat__value {
  margin: 0;
  display: inline-flex;
  align-items: baseline;
  gap: 4px;
  color: $p-ink;
}

.a-stat__num {
  font-family: $p-font-mono;
  font-size: 30px;
  font-weight: 800;
  line-height: 1;
  letter-spacing: -0.01em;
}

.a-stat__unit {
  font-size: 12px;
  font-weight: 600;
  color: $p-ink-mid;
}

.a-stat__delta {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  height: 22px;
  padding: 0 8px;
  border-radius: 999px;
  font-family: $p-font-mono;
  font-size: 11px;
  font-weight: 700;

  i { font-size: 13px !important; }

  &--up      { background: $p-ok-soft;  color: $p-ok; }
  &--down    { background: $p-err-soft; color: $p-err; }
  &--neutral { background: $p-panel-alt; color: $p-ink-mid; }
}

.a-stat__hint {
  margin: 0;
  font-size: 11px;
  color: $p-ink-soft;
}
</style>
